import { Checkbox, CheckboxProps, Text } from '@chakra-ui/react';
import * as React from 'react';

export const CompactCheckbox = React.forwardRef<
  HTMLInputElement,
  CheckboxProps
>(({ children, ...props }, ref) => {
  return (
    <Checkbox ref={ref} {...props}>
      <Text textStyle="compact" color="gray.600">
        {children}
      </Text>
    </Checkbox>
  );
});

CompactCheckbox.displayName = 'CompactCheckbox';
